module.exports = __webpack_public_path__ + "static/t2-18cc39edc2e54063e6db7f6e0fca1ceb.svg";